var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.ready)?_c('WeContainer',{attrs:{"header":"ture","actions":_vm.actions}},[_c('WeTable',{attrs:{"index":false,"data":_vm.membergroup.list,"columns":_vm.columns,"actions":_vm.tableActions},on:{"on-action":_vm.onAction}})],1):_c('WeLoading')}
var staticRenderFns = []

export { render, staticRenderFns }